var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawShareResultsLfh5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 611.175,
    viewBox: "0 0 960 611.175",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-321.696 -289.214)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.88 315.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315.702,
    height: 202.19,
    rx: 10,
    transform: "translate(0.135 0.179)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 297.647,
    height: 164.869,
    rx: 8,
    transform: "translate(9.27 25.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.218,0H244.549c7.3,0,13.218,1.409,13.218,3.147V101.7c0,1.738-5.918,3.147-13.218,3.147H13.218C5.918,104.844,0,103.435,0,101.7V3.147C0,1.409,5.918,0,13.218,0Z",
    transform: "translate(29.236 78.223)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.218,0H244.549c7.3,0,13.218.4,13.218.893V28.857c0,.493-5.918.893-13.218.893H13.218C5.918,29.75,0,29.35,0,28.857V.893C0,.4,5.918,0,13.218,0Z",
    transform: "translate(29.236 41.463)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.565,0H312.137A3.565,3.565,0,0,1,315.7,3.565v9.847H0V3.565A3.565,3.565,0,0,1,3.565,0Z",
    transform: "translate(0 0)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.486,
    cy: 2.486,
    r: 2.486,
    transform: "translate(7.481 4.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.486,
    cy: 2.486,
    r: 2.486,
    transform: "translate(16.916 4.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.486,
    cy: 2.486,
    r: 2.486,
    transform: "translate(26.352 4.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.988,189.773a39.679,39.679,0,1,0,2.25,58.6l48.67,41.068a3.656,3.656,0,0,0,4.721-5.585l-.005,0-48.671-41.068a39.681,39.681,0,0,0-6.966-53.01Zm-3.138,49.056a29.727,29.727,0,1,1-3.549-41.891h0A29.727,29.727,0,0,1,504.85,238.829Z",
    transform: "translate(-345.888 -102.197)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(801.688 296.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.471s39.486,40.71,50.984,71.95a60.6,60.6,0,1,0,58.579-10.314L88.815,0ZM150.031,136.29v0Z",
    transform: "translate(379.885 263.966) rotate(180)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.2,38.681c-.39-4.932-.463-7.379.634-10.617,2.324-6.868,4.779-13.972,9.792-19.195C502.2.993,514.267-1.021,525.1.442c13.919,1.88,27.655,9.4,34.132,21.884s3.707,29.875-7.989,37.66c16.685,19.116,22.485,40.421,21.57,65.756-.914,25.357-28.543,48.677-46.562,66.541-4.021-2.428-7.678-13.866-5.462-18.019s-.966-8.957,1.776-12.8c2.742-3.813,5.04,2.272,2.272-1.54-1.75-2.4,5.065-7.912,2.483-9.348-12.561-6.946-16.74-22.615-24.63-34.6A58.924,58.924,0,0,0,459.628,90.1c-9.505-.888-19.533.731-27.311,6.241S419.494,111.7,421.293,121.07a21.961,21.961,0,0,1,4.569-34.393,35.853,35.853,0,0,1,7.625-33.819c8.122-8.957,41.052-7.417,52.908-5.065A32.193,32.193,0,0,1,484.2,38.681Z",
    transform: "translate(-190.217 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.649,34.629c15.692,1.7,27.029,15.3,36.612,27.864,5.51,7.234,11.308,15.225,11.151,24.339-.13,9.193-6.294,17.1-9.244,25.8a38.9,38.9,0,0,0,11.308,40.973c-11.308,2.141-23.53-6.319-25.461-17.678-2.272-13.188,7.73-25.932,6.555-39.276C458.525,84.9,449.255,75.864,441.4,67.064c-7.887-8.8-15.277-20.448-11.647-31.681l-1.092-.758h0Z",
    transform: "translate(-131.523 55.803)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.819,657.578l4.133,86.8s-2.067,113.667,16.534,121.934c9.4,4.171,1.21,35.038,18.671,44.214,13.1,6.861,15.317-6.263,22.18,0a23.141,23.141,0,0,1,4.65,5.395c8.267,14.467,99.165,10.329,111.563-.008s4.133,12.4,14.467,16.534c10,4.009,23.869-28.768,15.376-77.707-.268-1.629-.579-3.285-.9-4.96-9.486-47.427,5.415-161.034,3.12-204.93a77.251,77.251,0,0,0-1.054-10c-6.2-33.066-85.311-100.356-100.1-71.692-18.228,35.382-60.1,3.059-67.29-13.033-41.334-2.067-55.8,47.533-55.8,47.533Z",
    transform: "translate(-52.318 -352.012)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.975,591.877l-11.337,46.769a2.92,2.92,0,0,0,.056,1.578l51.433,160.724a2.922,2.922,0,0,0,5.684-.561l7.116-62.609a2.923,2.923,0,0,0-.125-1.234L440.592,591.662a2.922,2.922,0,0,0-5.611.217Z",
    transform: "translate(-423.555 -293.821)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.415,432.512l-10.468,40.123L314.31,619.194l10.468-45.361Z",
    transform: "translate(-263.825 -130.512)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.8,728.219c-1.745,5.233-181.448-1.745-183.19-3.49a37.883,37.883,0,0,1-3.838-6.978c-1.64-3.49-3.14-6.978-3.14-6.978l6.978-56.492,177.957-6.315s4.449,47.87,5.356,69.788a52.339,52.339,0,0,1-.123,10.467Z",
    transform: "translate(-296.658 -208.126)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.875,493.975l-3.49,48.853H307.9V493.975Z",
    transform: "translate(-149.242 -40.185)",
    fill: "#d6d6e3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.883,500.39l-.469-.094,2.217,21.029h43.625V500.39Z",
    transform: "translate(-16.058 -30.899)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.663,686.686c-1.745,5.233-181.448-1.745-183.19-3.49a37.875,37.875,0,0,1-3.838-6.978H537.786a52.348,52.348,0,0,1-.123,10.468Z",
    transform: "translate(-293.518 -166.606)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.328,641.755l-55.8,28.934s-33.067-35.134-53.729-8.267,59.934,35.134,59.934,35.134S484,681.022,486.064,658.29,463.328,641.755,463.328,641.755Z",
    transform: "translate(-241.162 -218.387)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.015,561.794c-2.067,2.068-24.8,18.6-24.8,18.6s-6.2,78.532,2.067,95.067,14.467,16.534,8.267,24.8-14.467,2.067-6.2,16.534,16.534,12.4,10.329,18.6-4.133,8.267-4.133,8.267l-24.8,20.666s15.215,24.233,34.475,22.445,35.793-94.783,35.793-94.783Z",
    transform: "translate(-135.181 -334.756)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.865,6.411c-5.9,0-8.822-9.323-15.664-15.948-5.828-5.644-15.55-8.6-21.75-9.049-89.333-6.388-198.794-8.884-198.794-8.884s21.2,26.089,21.2,42.823c0,35.762,44.708,25.357,218.753,25.357s202.039,45.6,202.039,9.834S498.91,6.411,324.865,6.411Z",
    transform: "translate(-50.643 540.031)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.245,686.711l-33.067,8.265s-37.2-45.466-76.465-28.933,49.6,49.6,49.6,49.6,47.533,24.8,66.133,4.133S436.245,686.711,436.245,686.711Z",
    transform: "translate(-121.08 -186.874)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.442,581.878l18.6,6.194s49.6,181.867-8.267,212.867-121.934,62-124,53.729-24.8-41.334-18.6-45.466,97.13-53.729,97.13-53.729V614.942Z",
    transform: "translate(29.258 -305.244)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.682,452.785l4.13,99.2L131.28,603.65l101.269-51.668Z",
    transform: "translate(160.12 -100.715)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(666.598 497.393)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.236,
    height: 35.923,
    rx: 16,
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.971,
    height: 32.657,
    rx: 15,
    transform: "translate(1.633 1.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.83 7.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.342,0H17.367a4.342,4.342,0,0,1,4.342,4.342V17.367a4.342,4.342,0,0,1-4.342,4.342H4.342A4.342,4.342,0,0,1,0,17.367V4.342A4.342,4.342,0,0,1,4.342,0Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H68.744a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.775 8.829)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H39.8a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.775 19.684)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.524 289.214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.78,
    height: 35.923,
    rx: 16,
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.971,
    height: 32.657,
    rx: 15,
    transform: "translate(1.633 1.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.984 7.223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.342,0H17.367a4.342,4.342,0,0,1,4.342,4.342V17.367a4.342,4.342,0,0,1-4.342,4.342H4.342A4.342,4.342,0,0,1,0,17.367V4.342A4.342,4.342,0,0,1,4.342,0Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H68.744a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.927 9.031)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H39.8a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.927 19.885)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.414 370.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.78,
    height: 35.923,
    rx: 16,
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.971,
    height: 32.657,
    rx: 15,
    transform: "translate(1.633 1.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.952 7.241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.342,0H17.367a4.342,4.342,0,0,1,4.342,4.342V17.367a4.342,4.342,0,0,1-4.342,4.342H4.342A4.342,4.342,0,0,1,0,17.367V4.342A4.342,4.342,0,0,1,4.342,0Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H68.744a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.895 9.051)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H39.8a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.895 19.905)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(698.276 408.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.78,
    height: 36.467,
    rx: 16,
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.971,
    height: 32.657,
    rx: 15,
    transform: "translate(2.177 2.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.288 7.443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.342,0H17.367a4.342,4.342,0,0,1,4.342,4.342V17.367a4.342,4.342,0,0,1-4.342,4.342H4.342A4.342,4.342,0,0,1,0,17.367V4.342A4.342,4.342,0,0,1,4.342,0Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H68.744a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(38.233 9.253)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H39.8a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(38.233 20.107)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(321.696 461.47)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.78,
    height: 35.923,
    rx: 16,
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 141.515,
    height: 32.657,
    rx: 15,
    transform: "translate(1.633 1.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.046 7.102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.342,0H17.367a4.342,4.342,0,0,1,4.342,4.342V17.367a4.342,4.342,0,0,1-4.342,4.342H4.342A4.342,4.342,0,0,1,0,17.367V4.342A4.342,4.342,0,0,1,4.342,0Z",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H68.744a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.99 8.911)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.618,0H39.8a3.618,3.618,0,0,1,0,7.236H3.618A3.618,3.618,0,0,1,3.618,0Z",
    transform: "translate(37.99 19.766)",
    fill: "#e6e6e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawShareResultsLfh5);
export default __webpack_public_path__ + "static/media/undraw_share-results_lfh5.df7cef837040a19f094fb24385dac658.svg";
export { ForwardRef as ReactComponent };